// 足球 世界杯预选赛赛
export default {
  data() {
    return {
      containerFullClassName: 'containerFull_football_cup',
      defaultPath: ['football', 'WCQAsianZone', 'schedule'],
      axiosBaseUrl: '/ftcup',
      sportCompetitionType: 'football_WCQAsianZone', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber, compreSportsMeet_ASG】
      themeSeasonArr: [
        {
          sidArr: ['1122026'],
          themeIndex: 0,
        },
      ],
    }
  },
}
